
import React from 'react';

import ParameterItemGeneric from './ParameterItemGeneric';
import getParameterDefinitions from './getParameterDefinitions';

const ParameterItem = ({
    id,
    options,
    title,
    type,
    value,
    values,
    onConfirm,
    onChangeValue
}) => {

    return (
        <ParameterItemGeneric
            id={id}
            options={options}
            paramDefinitions={getParameterDefinitions()}
            title={title}
            type={type}
            value={value}
            values={values}
            onConfirm={onConfirm}
            onChangeValue={onChangeValue}
        />
    );
}

export default ParameterItem;
